<template>
  <div class="register">
    <img src="@/assets/img/pic_banner.png" alt />
    <div class="nav_pos">
      当前位置：
      <label class="index" @click.stop="$router.push('/')">首页</label>
      > 用户注册
    </div>
    <!-- <div class="nav_pos">
      <span class="text">当前位置：</span>
      <el-breadcrumb separator-class="el-icon-arrow-right">
        <el-breadcrumb-item v-for="(item, index) in $route.meta.breadUrl" :key="index">
          <router-link v-if="item.url" :to="item.url">
            {{
            item.name
            }}
          </router-link>
          <a v-else>{{ item.name }}</a>
        </el-breadcrumb-item>
      </el-breadcrumb>
    </div>-->
    <el-dialog
      :visible.sync="blackListShow1"
      title="黑名单供应商状态异常提醒"
      width="700px"
      class="dialog-wrap form-module"
      :close-on-press-escape="false"
      :show-close="true"
      :center="true"
      :close-on-click-modal="false"
    >
      <div style="padding-left: 0.625rem; padding-top: 0.9375rem" class="warn_content">
        <p>很遗憾，贵司仍在我司黑名单禁用期限内，禁用期截至{{ resultData.EntryTermEndDate }}</p>
      </div>
    </el-dialog>
    <el-dialog
      :visible.sync="blackListShow2"
      title="黑名单供应商解禁提醒"
      width="700px"
      class="dialog-wrap form-module"
      :close-on-press-escape="false"
      :show-close="true"
      :center="true"
      :close-on-click-modal="false"
    >
      <div style="padding-left: 0.625rem; padding-top: 0.9375rem" class="warn_content">
        <p>
          贵司已超过我司黑名单禁用期，处于“待激活”状态，若贵司希望与我司重新合作，请发起“黑名单解禁申请流程”，待我司相关评审通过后方能恢复“合格”状态
        </p>
        <div style="padding-top: 1rem; text-align: center">
          <el-button class="apply_btn" type="primary" @click="goToChangeInform()"> 发起黑名单解禁申请流程</el-button>
        </div>
      </div>
    </el-dialog>
    <Steps :active="1"></Steps>
    <!-- <div class="choose">
      <span>请选择您的类别：</span>
      <el-radio-group v-model="radio">
        <el-radio :label="1">法人或其他组织</el-radio>
        <el-radio :label="2">自然人</el-radio>
      </el-radio-group>
    </div> -->
    <el-tabs v-model="activeName" type="card">
      <el-tab-pane label="账号管理信息" name="first" class="first" :disabled="true">
        <div class="form_wrap form_register">
          <div class="form">
            <el-form :model="ruleForm" :rules="rules" ref="ruleForm">
              <div class="form_left">
                <el-form-item :label="socialCreditCodeName + '：'" prop="socialCreditCode" label-width="140px">
                  <el-input v-model="ruleForm.socialCreditCode" :placeholder="'请填写您的' + socialCreditCodeName"></el-input>
                  <!-- @blur="ruleLoginName" -->
                </el-form-item>
                <el-form-item label="用户名：" prop="loginName" label-width="140px">
                  <el-input v-model="ruleForm.loginName" placeholder="以字母开头，4-15位字母或数字"></el-input>
                  <!-- @blur="ruleLoginName" -->
                </el-form-item>
                <el-form-item label="密码：" prop="loginPwd" label-width="140px">
                  <el-input v-model="ruleForm.loginPwd" show-password placeholder="6-20位字母、数字或下划线"></el-input>
                </el-form-item>
                <el-form-item label="确认密码：" prop="reloginPwd" label-width="140px">
                  <el-input v-model="ruleForm.reloginPwd" show-password placeholder="请再输入一次密码"></el-input>
                </el-form-item>
                <el-form-item label="电子邮箱：" prop="Email" label-width="140px">
                  <el-input v-model="ruleForm.Email" placeholder="请填写您的电子邮箱"></el-input>
                </el-form-item>
                <el-form-item label="手机号码：" prop="mobile" label-width="140px" class="phone" ref="mobile">
                  <el-input v-model="ruleForm.mobile" placeholder="请填写您的手机号码"></el-input>
                  <span class="code" @mousedown.stop="setCode" :class="{ disabled }">{{ codeName }}</span>
                </el-form-item>
                <el-form-item label="验证码：" prop="authCode" label-width="140px">
                  <el-input v-model="ruleForm.authCode" placeholder="请输入手机验证码"></el-input>
                </el-form-item>
              </div>
              <div class="form_right">
                <div class="tig">【供应商注册重要提示】</div>
                <div>各级供应商用户：</div>
                <p>
                  当您在当前页面填写完成后，点击【下一步，完善供应商信息】时发生系统弹出或页面故障时；或者当您输入的注册手机号系统提示已被注册的情况，请不要在此页面重复填写注册账户信息。您可在首页右上角点击【登录】按钮，输入刚刚在此页面注册的账户信息完成平台登录（如提示密码错误，在您确认手机号正确且可正常接收短信的情况下，可通过手机号自行重置密码）。
                </p>
              </div>
            </el-form>
          </div>
        </div>
        <div class="btn_1" @click="next('ruleForm')">下一步，完善信息</div>
      </el-tab-pane>
      <el-tab-pane label="基本信息" name="second" :disabled="true">
        <RegisterForm v-if="radio == 1 && activeName == 'second'" ref="RegisterForm" :parentForm="ruleForm"></RegisterForm>
        <!-- <Personal v-if="radio == 2 && activeName == 'second'" ref="Personal" :parentForm="ruleForm"></Personal> -->
        <div class="btn_wrap">
          <span class="btn_1 btn" @click="back">上一步</span>
          <span class="btn_1" @click="submit(false)">保存草稿</span>
          <span class="btn_1" @click="submit(true)">提交申请</span>
        </div>
      </el-tab-pane>
    </el-tabs>
  </div>
</template>

<script>
import Steps from '@/components/common/Steps'
import jsSHA from '@/assets/js/sha.js'
import RegisterForm from '@/components/common/RegisterForm'
import Personal from '@/views/register/personal'
import { validamobileoginName, validatePass, validatePass2, validateEmail, validatemobile } from '@/assets/js/util'
export default {
  components: { Steps, RegisterForm, Personal },
  data() {
    return {
      radio: 1,
      activeName: 'first',
      ruleForm: {
        socialCreditCode: '',
        loginName: '',
        loginPwd: '',
        reloginPwd: '',
        Email: '',
        mobile: '',
        authCode: ''
      },
      codeName: '短信获取验证码',
      disabled: false,
      isMobileRight: false,
      isLoginNameRight: false,
      DisabledTime: 0,
      socialCreditCodeName: '社会信用代码',
      rules: {
        socialCreditCode: [{ required: true, message: '请输入社会信用代码', trigger: 'blur' }],
        loginName: [{ required: true, validator: validamobileoginName, trigger: 'blur' }],
        loginPwd: [{ required: true, validator: validatePass, trigger: 'blur' }],
        reloginPwd: [{ required: true, validator: validatePass2, trigger: 'blur' }],
        Email: [{ required: true, validator: validateEmail, trigger: 'blur' }],
        mobile: [{ required: true, validator: validatemobile, trigger: 'blur' }],
        authCode: [{ required: true, message: '请输入验证码', trigger: 'blur' }]
      },
      resultData: {},
      blackListShow1: false,
      blackListShow2: false
    }
  },
  watch: {
    radio: function (newVal) {
      if (newVal == 1) {
        this.socialCreditCodeName = '社会信用代码'
      } else {
        this.socialCreditCodeName = '身份证号码'
      }
    }
  },

  methods: {
    setCode() {
      if (!this.ruleForm.loginName) {
        this.$message.error('请输入注册账号')
        return
      }
      if (!this.ruleForm.mobile) {
        this.$message.error('请输入手机号码')
        return
      }
      this.$refs['ruleForm'].validateField('mobile', (valid) => {
        if (!valid) {
          this.$refs['ruleForm'].validateField('loginName', (valid) => {
            if (!valid) {
              if (!this.disabled) {
                this.postRequest('SupplierLogin/SendValidateCode', {
                  mobile: this.ruleForm.mobile,
                  loginName: this.ruleForm.loginName,
                  type: 0
                }).then((res) => {
                  if (res.data.errcode == 0) {
                    let time = res.data.disabledTime
                    let timer = setInterval(() => {
                      this.disabled = true
                      if (time == 0) {
                        this.codeName = '短信获取验证码'
                        clearInterval(timer)
                        this.disabled = false
                      } else {
                        this.codeName = '重新发送(' + time + ')'
                        time--
                      }
                    }, 1000)
                  }
                })
              }
            }
          })
        }
      })
    },
    next(formName) {
      // this.activeName = "second";
      this.$refs[formName].validate((valid, object) => {
        console.log(valid)
        if (valid) {
          this.postRequest('SupplierLogin/ValidateAuthCode', {
            authCode: this.ruleForm.authCode,
            loginName: this.ruleForm.loginName,
            socialCreditCode: this.ruleForm.socialCreditCode
          })
            .then((res) => {
              if (res.data.errcode == 0) {
                this.ruleForm.enloginName = res.data.loginName
                this.activeName = 'second'
              } else if (res.data.errcode == 1) {
                this.$message.error(res.data.errmsg)
              } else if (res.data.errcode == 2) {
                this.resultData = res.data.resultData
                this.blackListShow1 = true
              } else if (res.data.errcode == 3) {
                this.blackListShow2 = true
              }
            })
            .catch(function (error) {
              console.log(error)
            })
        } else {
          setTimeout(() => {
            const isError = document.getElementsByClassName('is-error')
            isError[0].querySelector('input').focus()
          }, 100)
          return false
        }
      })
    },
    back() {
      this.activeName = 'first'
      this.radio = 1
    },

    async submit(Submit) {
      let form,
        isSubmit = true,
        filelist = [],
        filelist1,
        contactDataList
      if (this.radio == 1) {
        if (Submit == true) {
          this.$refs.RegisterForm.$refs.MsgForm1.ruleList()
          isSubmit = this.$refs.RegisterForm.$refs.MsgForm1.iserror
          if (this.$refs.RegisterForm.$refs.MsgForm1.iserror) {
            this.$refs.RegisterForm.$refs.MsgForm3.ruleList()
            isSubmit = this.$refs.RegisterForm.$refs.MsgForm3.iserror
            if (this.$refs.RegisterForm.$refs.MsgForm3.iserror) {
              this.$refs.RegisterForm.$refs.MsgForm4.ruleList()
              isSubmit = this.$refs.RegisterForm.$refs.MsgForm4.iserror
              if (this.$refs.RegisterForm.$refs.MsgForm4.iserror) {
                isSubmit = await this.$refs.RegisterForm.formRule()
                if (isSubmit) {
                  form = this.$refs.RegisterForm.ruleForm
                  if (form.TaxPayerSize != 3 && form.TaxPayerSize != 4) {
                    this.$refs.RegisterForm.$refs.QualificationForm.ruleList()
                    isSubmit = this.$refs.RegisterForm.$refs.MsgForm4.iserror
                  }
                }
              }
            }
          }
        } else {
          this.$refs.RegisterForm.$refs.MsgForm1.ruleList1()
          this.$refs.RegisterForm.$refs.MsgForm3.ruleList1()
          this.$refs.RegisterForm.$refs.MsgForm4.ruleList1()
          if (this.$refs.RegisterForm.$refs.hasOwnProperty('QualificationForm')) {
            this.$refs.RegisterForm.$refs.QualificationForm.ruleList1()
          }
        }
        form = this.$refs.RegisterForm.ruleForm
        contactDataList = this.$refs.RegisterForm.spplierContactList
        const seen = new Set()

        contactDataList = contactDataList.filter((item) => {
          return !seen.has(item.ContactName) && seen.add(item.ContactName)
        })
        if (form.TaxPayerSize != 3 && form.TaxPayerSize != 4) {
          filelist1 = this.$refs.RegisterForm.$refs.QualificationForm.list
        }
        filelist.push(...this.$refs.RegisterForm.$refs.MsgForm1.list)
        // filelist.push(...this.$refs.RegisterForm.$refs.MsgForm3.list)
        // filelist.push(...this.$refs.RegisterForm.$refs.MsgForm4.list)
      }
      // else {
      //   form = this.$refs.Personal.ruleForm
      //   if (Submit == true) {
      //     this.$refs.Personal.$refs.MsgForm.ruleList()
      //     isSubmit = this.$refs.Personal.$refs.MsgForm.iserror
      //     // window.console.log(this.$refs.Personal.$refs.MsgForm.ruleList());
      //     if (this.$refs.Personal.$refs.MsgForm.iserror) {
      //       isSubmit = await this.$refs.Personal.formRule()
      //     }
      //   }

      //   filelist = this.$refs.Personal.$refs.MsgForm.list
      // }
      if (isSubmit) {
        this.radio == 1 ? (form.SupplierCategory = 0) : (form.SupplierCategory = 1)

        this.postData(form, filelist, filelist1, contactDataList, Submit)
      }
    },
    postData(form, filelist, fileList1, contactDataList, isSubmit) {
      var shaObj = new jsSHA(this.ruleForm.loginPwd, 'TEXT')
      this.ruleForm.loginPwd = shaObj.getHash('SHA-1', 'HEX')

      this.postRequest('SupplierLogin/BaseDataSave', {
        accountDataJson: JSON.stringify(this.ruleForm),
        fileListJson: JSON.stringify(filelist),
        baseDataJson: JSON.stringify(form),
        qualificationListJson: JSON.stringify(fileList1),
        contactDataListJson: JSON.stringify(contactDataList),
        isSubmit: isSubmit
      })
        .then((res) => {
          if (res.data.errcode == 0) {
            if (isSubmit) {
              this.$router.push({
                //传外键值到审核进度详细页面
                path: '/SuccessApply',
                query: { name: '注册流程信息' }
              })
            } else {
              if (form.SupplierCategory == 0) {
                this.$router.push({
                  //传外键值到审核进度详细页面
                  path: '/RegisterForm',
                  query: { loginName: res.data.loginName }
                })
              } else {
                this.$router.push({
                  //传外键值到审核进度详细页面
                  path: '/personal',
                  query: { loginName: res.data.loginName }
                })
              }
            }
          } else {
            this.$message.error(res.data.errmsg)
          }
        })
        .catch(function (error) {
          console.log(error)
        })
    },
    goToChangeInform() {
      this.$router.push({
        path: '/unbanInform',
        query: {
          ruleForm: JSON.stringify(this.ruleForm),
          isEnter: true
        }
      })
    }
  }
}
</script>

<style lang="scss" scoped>
.warn_content p {
  text-indent: 2em;
  line-height: 2em;
  font-size: 20px;
}
.register {
  .choose {
    height: 100px;
    line-height: 100px;
    text-align: center;
    span {
      margin-right: 10px;
      font-weight: bold;
      color: #ff6600;
    }
  }
  ::v-deep .el-tabs {
    margin: 0 15px;
    .el-tabs__item {
      height: 38px;
      line-height: 38px;
      width: 325px;
      text-align: center;
      font-weight: bold;
      color: #999999;
      border-color: #ccc;
      background: #fff;
    }
    .el-tabs__nav,
    .el-tabs__header {
      border-radius: 0;
      border-color: #ccc;
    }
    .el-tabs__header {
      margin: 0;
    }
    .is-active {
      color: #fff;
      border-color: #0774c5;
      background: #0774c5;
    }
  }
  .form_wrap {
    .form_left {
      padding-right: 40px;
      border-right: 1px dashed #76b7eb;
    }
    .form_right {
      padding-left: 40px;
      line-height: 28px;
      .tig {
        margin-left: -6px;
        margin-bottom: 15px;
        color: #0774d7;
      }
      p {
        text-indent: 2em;
      }
    }
    .phone {
      position: relative;
      .code {
        position: absolute;
        top: 4px;
        line-height: 26px;
        right: 6px;
        padding: 0px 12px;
        border-radius: 20px;
        color: #fff;
        background: #76b7eb;
        cursor: pointer;
      }
      .disabled {
        background: #ccc;
      }
    }
  }
  .first {
    .btn_1 {
      font-weight: bold;
      position: relative;
      left: 50%;
      transform: translateX(-50%);
      margin: 40px 0 100px;
      width: 160px;
    }
  }
  .form_register {
    margin-top: 15px;
  }
  .btn_wrap {
    width: 500px;
    margin: 30px auto 50px;
    .btn_1 {
      font-weight: bold;
      margin: 0 30px;
    }
    .btn {
      color: #fff;
      background: #2db7f5;
    }
  }
}
</style>
